import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Box, Button, ShadowBox } from '@components/common';
import { TableHeading } from '@components/Typography';
import { AuthSelectors } from '@redux/AuthRedux';
import KeyReleaseModal from './KeyReleaseModal';
import ApartmentModal from './ApartmentModal';
import TableCell from '@components/TableCell';
import history from '@utils/history';

function ApartmentInfo(props) {
  const { user } = props;
  const {
    bedroomsCount,
    buildingName,
    unitNumber,
    hasPets,
    propertyName
  } = user;
  const [showKeyRelease, toggleKeyRelease] = useState(false);
  const [showApartment, toggleApartment] = useState(false);

  const handleViewKeyRelease = () => {
    toggleKeyRelease(true);
  };

  const handleConfirmMoving = () => {
    history.push('/moveout');
  };

  return (
    <React.Fragment>
      <Box
        mb={4}
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        width={1}
      >
        <TableHeading>My Apartment</TableHeading>
      </Box>

      <ShadowBox mb={4}>
        <TableCell title="Property" rightText={propertyName} />
        <TableCell title="Building" rightText={buildingName} />
        <TableCell title="Unit Number" rightText={unitNumber} />
        <TableCell
          title="Number of Bedrooms"
          rightText={bedroomsCount ? bedroomsCount : 'Studio'}
        />
        <TableCell title="Pets" rightText={hasPets ? 'Yes' : 'No'} />
      </ShadowBox>
      <Box
        display={['none', 'flex']}
        flexDirection="row"
        justifyContent="space-between"
        mb={4}
        width={1}
      >
        <Button
          variant="secondary"
          size="small"
          mb={4}
          mr={4}
          onClick={handleViewKeyRelease}
        >
          View Key Release
        </Button>
        <Button
          variant="secondary"
          size="small"
          mb={4}
          onClick={handleConfirmMoving}
        >
          Edit
        </Button>
      </Box>
      <Box display={['flex', 'none']} flexDirection="column" mb={4}>
        <Button variant="secondary" mb={4} onClick={handleConfirmMoving}>
          Update
        </Button>
        <Button variant="secondary" mb={4} onClick={handleViewKeyRelease}>
          View Key Release
        </Button>
      </Box>
      <KeyReleaseModal
        show={showKeyRelease}
        dismiss={() => toggleKeyRelease(false)}
      />
      <ApartmentModal
        show={showApartment}
        dismiss={() => toggleApartment(false)}
      />
    </React.Fragment>
  );
}

ApartmentInfo.propTypes = {
  user: PropTypes.object
};

const mapStatesToProps = state => ({
  user: AuthSelectors.selectCurrentUser(state)
});

export default connect(mapStatesToProps)(ApartmentInfo);
